import { render, staticRenderFns } from "./FactorScore.vue?vue&type=template&id=308ab406&scoped=true&"
import script from "./FactorScore.vue?vue&type=script&lang=ts&"
export * from "./FactorScore.vue?vue&type=script&lang=ts&"
import style0 from "./FactorScore.vue?vue&type=style&index=0&id=308ab406&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ab406",
  null
  
)

export default component.exports